import { render, staticRenderFns } from "./PendingProfileChangeAll.vue?vue&type=template&id=03c53450&"
import script from "./PendingProfileChangeAll.vue?vue&type=script&lang=js&"
export * from "./PendingProfileChangeAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports